import React, {Component} from 'react';
import {HashRouter as Router, Route} from "react-router-dom";
import './App.css';
import './Transitions.css';
import About from './components/About.js';
import LoadingScreen from './components/LoadingScreen.js';
import Map from './components/Map.js';
import TopBar from './components/TopBar.js';
import {TransitionGroup, CSSTransition} from "react-transition-group";

class App extends Component {
  state = {
    dataLoaded: false
  }
  onDataLoaded = () => {
    this.setState({dataLoaded: true})
  }
  render() {
    return (
      <Router basename={window.location.pathname}>
        <Route render={({location}) => (
          <div id="content" className={location.pathname === '/embed' ? 'embed' : ''}>
            { !this.state.dataLoaded && <LoadingScreen/> }
            <Map onDataLoaded={this.onDataLoaded}></Map>
            <div id="ui">
              <TopBar/>
              <TransitionGroup>
                <CSSTransition
                  key={location.key}
                  classNames="fade"
                  timeout={300}
                >
                  <Route path="/about" component={About}/>
                </CSSTransition>
              </TransitionGroup>
            </div>
          </div>
        )}/>
      </Router>
    );
  }
}

export default App;
